import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllCompanyDetails,
  CreateCompanyDetails,
  UpdateCompanyDetails,
  getCompanyById,
} from "../../Apis/companyDetailsApi";
import { GetState, GetCity } from "../../Apis/countryApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";
import { useNavigate } from "react-router-dom";
const Company = () => {
  const navigate = useNavigate();
  const headers = [
    "state_name",
    "city_name",
    "company_name",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [editCompanyData, setEditCompanyData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formInput, setFormInput] = useState({
    state_id: "",
    city_id: "",
    company_name: "",
    status: "",
    company_email: "",
    password: "",
    mobile: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = "";

    // Sanitize input based on field name
    switch (name) {
      case "mobile":
        // Only allow numbers and limit to exactly 10 digits
        sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
        break;
      case "email":
        // Sanitize email input (if needed)
        sanitizedValue = value; // No sanitization for email field
        break;
      case "employee_id":
        // Only allow numbers (if needed)
        sanitizedValue = value.replace(/\D/g, "");
        break;
      case "company_name":
        // Allow up to 10 characters, including numbers and uppercase letters
        sanitizedValue = value
          .slice(0, 100)
          .replace(/[^A-Za-z\s]/g, "")
          .toUpperCase();
        break;
      // Add cases for other fields if needed
      default:
        sanitizedValue = value; // No sanitization for other fields
    }

    // Update the state with sanitized value
    setFormInput((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  };

  const handleClose = () => {
    setFormInput({
      state_id: "",
      city_id: "",
      company_name: "",
      status: "",
      company_email: "",
      password: "",
      mobile: "",
    });
    setLgShow(false); // Explicitly set lgShow to false
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    setFormInput({
      id: "",
      state_id: "",
      city_id: "",
      company_name: "",
      status: "",
      company_email: "",
      password: "",
      mobile: "",
    });
    setEditCompanyData(null);
  };

  const handleEditCompanyData = (selectedCompanyDetails) => {
    setEditCompanyData(selectedCompanyDetails);
    setIsLoading(true); // Set loading state
    setTimeout(() => {
      setIsLoading(false); // Clear loading state after a delay
    }, 1000);
    // Extract email from selected company details and set it in the form input
    setFormInput({
      ...formInput, // Keep other form inputs unchanged
      company_email: selectedCompanyDetails.company_email, // Set email from selected company
      id: selectedCompanyDetails.id,
      state_id: selectedCompanyDetails.state_id,
      city_id: selectedCompanyDetails.city_id,
      company_name: selectedCompanyDetails.company_name,
      company_email: selectedCompanyDetails.company_email,
      password: selectedCompanyDetails.password,
      mobile: selectedCompanyDetails.mobile,
      status: selectedCompanyDetails.status,
    });
    setLgShow(true); // Show the modal
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await AllCompanyDetails();
      setCompanyDetails(response.data);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(
    () => {
      fetchData();
    },
    []
    //[lgShow]
  );

  useEffect(() => {
    // Fetch state data from the API
    const fetchStateData = async () => {
      try {
        setIsLoading(true);
        const response = await GetState();
        setStates(response); // Update the state with fetched data
      } catch (error) {
        console.error("Error fetching state data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStateData(); // Call the function to fetch state data
  }, []);

  // Fetch state data from the API
  const fetchCityData = async () => {
    try {
      setIsLoading(true);
      const response = await GetCity();
      setCities(response); // Update the state with fetched data
    } catch (error) {
      console.error("Error fetching state data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchCityData(); // Call the function to fetch state data
  }, []);

  const handleCreateVehicleTypeDetails = async (e) => {
    e.preventDefault();
    // Basic validation checks
    // if (!formInput.name) {
    //   toast.error("Please fill in all required fields");
    //   return;
    // }

    try {
      setIsLoading(true);
      if (editCompanyData) {
        const updatedCompanyData = { ...formInput };
        const response = await UpdateCompanyDetails(updatedCompanyData);
        setCompanyDetails([...companyDetails, response]);
        toast.success("Company Details updated successfully");
        fetchData();
        fetchCityData();
        // Update the state with the modified data
        handleClose();
      } else {
        const response = await CreateCompanyDetails(formInput);
        // setVehicleTypeDetails([...vehicleTypeDetails, response]);
        toast.success("Company Details Created successfully");
      }
      fetchCityData();
      fetchData();
      handleClose();
      // Close the modal after success
    } catch (error) {
      // Handle form submission error, including validation errors
      if (error.response && error.response.status === 422) {
        // Backend returned validation errors
        const validationErrors = error.response.data.errors;
        // Iterate through validation errors and show corresponding toast notifications
        for (const field in validationErrors) {
          toast.error(`${validationErrors[field][0]}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Update formInput when editDriverData changes
    setFormInput(
      editCompanyData || {
        state_id: "",
        city_id: "",
        company_name: "",
        status: "",
      }
    );
  }, [editCompanyData]);

  const handleViewCompanyData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(true);
      // const response = await getCompanyById(id);
      const response = await getCompanyById(id);
      const companyDetails = response.data.data[0];
      navigate("/company-details", { state: { companyDetails } });
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="text-end mb-3">
                <button className="button-container" onClick={handleShow}>
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                  Add Company
                </button>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span>Company Details</span>
                </div>
                <TableComponent isLoading={isLoading}
                  DataFetchURL={companyDetails}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditCompanyData}
                  editDataDetails={editCompanyData}
                  viewData={(id) => handleViewCompanyData(id)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editCompanyData ? "Edit Company " : "Add Company "}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateVehicleTypeDetails}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">State Name <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.state_id}
                    name="state_id"
                    className="form-select"
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.state_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">City Name <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.city_id}
                    name="city_id"
                    className="form-select"
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {cities.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.city_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Company Name <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    name="company_name"
                    value={formInput.company_name}
                    className="form-control"
                    placeholder="Enter Company Name"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Company Email <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="email"
                    name="company_email"
                    value={formInput.company_email}
                    className="form-control"
                    placeholder="Enter Company Email"
                    onChange={handleInputChange}
                    autoComplete="new-email"
                  />
                </div>
              </div>
              {editCompanyData ? (
                ""
              ) : (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <label className="form-label">Password <span style={{ color: '#EC1117' }}> *</span></label>
                    <input
                      type="password"
                      name="password"
                      value={formInput.password}
                      className="form-control"
                      placeholder="Enter password"
                      onChange={handleInputChange}
                      autoComplete="new-password"
                    />
                  </div>
                </div>
              )}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Mobile Number <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="number"
                    name="mobile"
                    value={formInput.mobile}
                    className="form-control"
                    placeholder="Enter Mobile Number"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label">Status<span style={{ color: '#EC1117' }}> *</span></label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      id="activeRadio"
                      value={1}
                      checked={parseInt(formInput.status, 10) === 1}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "status", value: 1 },
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "40px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      id="inactiveRadio"
                      value={0}
                      checked={parseInt(formInput.status, 10) === 0}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "status", value: 0 },
                        })
                      }
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="deployment-button">
                <i class="fa-solid fa-check done-container"></i>
                {editCompanyData ? "Update Company" : "Add Company"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Company;
